import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  CLIENT_PAUSE_TITLE,
  CLIENT_PAUSE_ICON,
  VALID_CLIENT_PAUSE,
  CLIENT_PAUSE_VALUE_RANGE,
  CLIENT_PAUSE_KEYS,
  CLIENT_PAUSE_KEYS_PROJECT,
} from '@src/constants/tts';
import Typography from '@src/new-components/Typography';
import CustomNumberInput from '@src/components/CustomNumberInput';
import { StyledPunctuationList } from './index.style';

const PunctuationList = ({ clientPause, handleChangeSeconds, isProject }) => {
  const { t } = useTranslation();

  const clientPauseKeys = isProject
    ? CLIENT_PAUSE_KEYS_PROJECT
    : CLIENT_PAUSE_KEYS;

  // paragraphBreak and blockEndBreak min value is 0
  const punctuationsZeroValue = ['paragraphBreak', 'blockEndBreak'];

  return (
    <StyledPunctuationList>
      {clientPauseKeys.map((punctuation) => (
        <Box className="client-pause-item" key={punctuation}>
          <span className="client-pause-title">
            <Typography variant="body-14-regular">
              {t(CLIENT_PAUSE_TITLE[punctuation])}
            </Typography>
            <img
              src={CLIENT_PAUSE_ICON[punctuation]}
              alt={punctuation}
              className="client-pause-icon"
            />
          </span>
          <div className="number-input-wrapper">
            <CustomNumberInput
              className="number-input dashed-border mr-18"
              onChange={(sec) => handleChangeSeconds(punctuation, sec)}
              value={clientPause[punctuation]}
              min={
                punctuationsZeroValue.includes(punctuation)
                  ? 0
                  : VALID_CLIENT_PAUSE.min
              }
              max={VALID_CLIENT_PAUSE.max}
              suffix="s"
              valueRange={CLIENT_PAUSE_VALUE_RANGE}
            />
          </div>
        </Box>
      ))}
    </StyledPunctuationList>
  );
};

export default PunctuationList;
